/*
 * Copyright (c) 2020. FINN Sp. z o.o.
 */

package pl.finn.forms.swz

import io.kvision.navigo.Navigo
import io.kvision.routing.Routing
import pl.finn.forms.App
import pl.finn.forms.utils.stringProperty

fun Routing.swzRouting(app: App): Navigo {
    return on("/skarga_wniosek_zapytanie_do_urzedu_nowy/:token", { params ->
        Model.nowy(stringProperty(params, "token"), app)
    }).on("/skarga_wniosek_zapytanie_do_urzedu_edycja/:token", { params ->
        Model.edycja(stringProperty(params, "token"), app)
    })
}